import { usePageContext } from "vike-react/usePageContext";

/**
 * Replacement for react-router's useLocation().
 */
export function useLocation() {
  const pageContext = usePageContext();
  return {
    pathname: pageContext.urlPathname,
    search: typeof window !== "undefined" ? window.location.search : "",
    hash: typeof window !== "undefined" ? window.location.hash : "",
  };
}
